import { Helmet } from 'react-helmet-async';
import './StaticPages.css';

export default function Privacy() {
  return (
    <div className="static-page">
      <Helmet><title>Privacy Policy - MiniMom Co</title></Helmet>
      <div className="static-page-header">
        <h1>Privacy Policy</h1>
        <p>Last updated: April 2026</p>
      </div>
      <div className="static-page-content">
        <section className="static-section">
          <h2>1. Information We Collect</h2>
          <p>We collect the following types of information when you use our website:</p>
          <ul>
            <li><strong>Personal Information:</strong> Name, email address, phone number, shipping and billing address when you create an account or place an order.</li>
            <li><strong>Payment Information:</strong> Payment details are processed securely through our payment partners. We do not store your full card details on our servers.</li>
            <li><strong>Usage Data:</strong> Browser type, IP address, pages visited, time spent on site, and other analytics data to improve your experience.</li>
            <li><strong>Device Information:</strong> Device type, operating system, and unique device identifiers.</li>
          </ul>
        </section>

        <section className="static-section">
          <h2>2. How We Use Your Information</h2>
          <p>We use the information we collect to:</p>
          <ul>
            <li>Process and fulfill your orders</li>
            <li>Communicate about your orders, account, and customer service inquiries</li>
            <li>Send promotional emails and offers (you can opt out at any time)</li>
            <li>Improve our website, products, and services</li>
            <li>Prevent fraud and enhance security</li>
            <li>Comply with legal obligations</li>
          </ul>
        </section>

        <section className="static-section">
          <h2>3. Information Sharing</h2>
          <p>
            We do not sell, trade, or rent your personal information to third parties. We may share your
            information with:
          </p>
          <ul>
            <li><strong>Shipping Partners:</strong> To deliver your orders.</li>
            <li><strong>Payment Processors:</strong> To securely process your payments.</li>
            <li><strong>Analytics Providers:</strong> To help us understand website usage (data is anonymized).</li>
            <li><strong>Legal Authorities:</strong> When required by law or to protect our rights.</li>
          </ul>
        </section>

        <section className="static-section">
          <h2>4. Data Security</h2>
          <p>
            We implement industry-standard security measures to protect your personal information. All data
            transmitted between your browser and our servers is encrypted using 256-bit SSL technology.
            However, no method of electronic transmission is 100% secure, and we cannot guarantee absolute
            security.
          </p>
        </section>

        <section className="static-section">
          <h2>5. Cookies</h2>
          <p>
            Our website uses cookies to enhance your browsing experience. Cookies help us remember your
            preferences, keep you logged in, and understand how you interact with our site. You can manage
            cookie preferences through your browser settings. Disabling cookies may affect some website
            functionality.
          </p>
        </section>

        <section className="static-section">
          <h2>6. Your Rights</h2>
          <p>You have the right to:</p>
          <ul>
            <li>Access and review the personal information we hold about you</li>
            <li>Request correction of inaccurate data</li>
            <li>Request deletion of your account and associated data</li>
            <li>Opt out of marketing communications</li>
            <li>Withdraw consent for data processing where applicable</li>
          </ul>
          <p>To exercise any of these rights, please contact us at privacy@minimomco.com.</p>
        </section>

        <section className="static-section">
          <h2>7. Children's Privacy</h2>
          <p>
            While our products are designed for children, our website is intended for use by adults (parents
            and guardians). We do not knowingly collect personal information from children under 13. If we
            become aware that we have collected data from a child under 13, we will delete it promptly.
          </p>
        </section>

        <section className="static-section">
          <h2>8. Changes to This Policy</h2>
          <p>
            We may update this Privacy Policy from time to time. Changes will be posted on this page with
            an updated date. We encourage you to review this policy periodically.
          </p>
        </section>

        <section className="static-section">
          <h2>9. Contact Us</h2>
          <p>
            For questions or concerns about this Privacy Policy, contact us at privacy@minimomco.com
            or through our Support page.
          </p>
        </section>
      </div>
    </div>
  );
}
